import React, { useState } from 'react';

import ImageSlider from '@features/pom/components/ImageSlider';
import PomViewModal from '@features/pom/components/PomViewModal';

import { ORGANIZTION_INFO } from '@utils/Util';

const PomCardView = ({ isCheckBox, onCheckBoxClick, selectedPomIds, pomList, fromPage }) => {
	const [selectedImage, setSelectedImage] = useState([]);
	const [selectedPom, setSelectedPom] = useState(null);

	const getPomId = (item) => {
		// item?.pointOfMeasurement?.libraryPOMId
		return item?.pointOfMeasurement?.id;
	};
	return (
		<div className="pom-card-view pb-3">
			<div className="pom-category-wise">
				{pomList?.map((item) => {
					const NITEX_DATA = item?.brandDetailsResponseList?.find(
						(item) => item?.brandResponse?.name === ORGANIZTION_INFO?.name
					);
					return (
						<div
							className={`single-design-card with-editable ${
								selectedPomIds?.includes(
									fromPage === 'MEASUREMENT' ? getPomId(item) : item?.id
								)
									? 'selected-box'
									: ''
							}`}
							key={item?.id}
						>
							{isCheckBox && (
								<div className="edit-items">
									<div className="custom-chekbox ">
										<div className="form-group">
											<input
												type="checkbox"
												id={fromPage === 'MEASUREMENT' ? getPomId(item) : item?.id}
												name="Company"
												onChange={(e) => onCheckBoxClick(e, item)}
												checked={selectedPomIds?.includes(
													fromPage === 'MEASUREMENT' ? getPomId(item) : item?.id
												)}
											/>
											<label
												htmlFor={
													fromPage === 'MEASUREMENT' ? getPomId(item) : item?.id
												}
											/>
										</div>
									</div>
								</div>
							)}
							<div onClick={() => setSelectedPom(item?.id)}>
								<ImageSlider
									type="CARD_VIEW"
									imageList={item?.visualResponseList}
									item={item}
									selectedImage={selectedImage}
									setSelectedImage={setSelectedImage}
								/>
							</div>
							<div className="card-content">
								<p className="gray_dark_02 regular-12 code-number">{NITEX_DATA?.pomCode}</p>
								<h3 className="regular-12 gray_dark_01 design-title weight-500">
									{NITEX_DATA?.pomName}
								</h3>
							</div>
						</div>
					);
				})}
			</div>
			{selectedPom && <PomViewModal pomId={selectedPom} onClose={() => setSelectedPom(null)} />}
		</div>
	);
};

export default PomCardView;
